import { Seo, breadcrumbJsonLd } from "@/lib/Seo";
import { PageHeader } from "@/components/PageHeader";
import { EMAIL } from "@/data/content";

const BREADCRUMB = [
  { name: "Home", path: "/" },
  { name: "Cookieverklaring", path: "/cookieverklaring" },
];

const H = ({ children }) => <h2 className="mt-10 font-heading text-base font-bold text-[#F5F7F9] md:text-lg">{children}</h2>;
const P = ({ children }) => <p className="mt-3 text-sm leading-relaxed text-[#CBD3D9]/85">{children}</p>;

export default function CookiesPage() {
  return (
    <>
      <Seo
        title="Cookieverklaring | Brandpreventie Recycling"
        description="Lees welke cookies brandpreventierecycling.nl gebruikt en hoe u uw cookievoorkeuren kunt aanpassen."
        jsonLd={[breadcrumbJsonLd(BREADCRUMB)]}
      />
      <PageHeader overline="Juridisch" title="Cookieverklaring" breadcrumb={BREADCRUMB} />
      <section className="py-16">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-10" data-testid="cookies-content">
          <P>
            Deze website maakt gebruik van cookies. Cookies zijn kleine tekstbestanden die op uw
            apparaat worden opgeslagen. Hieronder leest u welke categorieën cookies wij gebruiken.
          </P>
          <H>Noodzakelijke cookies</H>
          <P>
            Deze cookies zijn nodig voor de basisfunctionaliteit van de website, zoals het onthouden
            van uw cookievoorkeuren en het beveiligen van formulieren. Ze worden altijd geplaatst en
            bevatten geen persoonsgegevens voor marketingdoeleinden.
          </P>
          <H>Statistiekcookies</H>
          <P>
            Met uw toestemming gebruiken wij statistiekcookies (zoals Google Analytics) om anoniem
            inzicht te krijgen in het gebruik van de website. Deze gegevens helpen ons de website te
            verbeteren. Statistiekcookies worden pas geladen nadat u hiervoor toestemming heeft
            gegeven.
          </P>
          <H>Marketingcookies</H>
          <P>
            Marketingcookies worden alleen geplaatst wanneer u hiervoor toestemming geeft. Deze
            cookies kunnen worden gebruikt om de effectiviteit van campagnes te meten.
          </P>
          <H>Voorkeuren aanpassen</H>
          <P>
            U kunt uw cookievoorkeuren op ieder moment aanpassen via de knop "Cookievoorkeuren
            aanpassen" onderaan iedere pagina. Daarnaast kunt u cookies verwijderen via de
            instellingen van uw browser.
          </P>
          <H>Vragen?</H>
          <P>Neem contact op via {EMAIL}.</P>
        </div>
      </section>
    </>
  );
}
